// extracted by mini-css-extract-plugin
export default {"container":"Testimonials_container__n-cHL","title":"Testimonials_title__+rt+3","sub__title":"Testimonials_sub__title__nLPk-","grid__box":"Testimonials_grid__box__RC4oP"};